/**
 * Плашка вместо карты, когда доменом и правами организации не разрешён ни один
 * район.
 *
 * Состояние реальное, а не теоретическое: организацию заводят раньше, чем
 * дописывают ей балтийский район. Показать в этот момент пустой экран нельзя —
 * он неотличим от аварии бэкенда, и человек звонит в поддержку не по адресу.
 *
 * Слова берутся из каталога по КОДУ сервера (`region_forbidden`): в коде
 * кабинета подписей нет.
 */

import { Icon } from '../brand/Icon'
import { useT } from '../i18n'

export function RegionForbiddenPlate() {
  const t = useT()
  return (
    <div className="pointer-events-none absolute left-1/2 top-1/2 z-10 max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-xl border border-hull bg-abyss/85 px-5 py-4 text-center shadow-console backdrop-blur">
      <Icon name="ic-layers" className="mx-auto mb-2 h-9 w-9 text-mist" />
      <div className="text-sm font-semibold text-foam">{t('maps.regionForbidden.title')}</div>
      <div className="mt-1 text-xs text-mist">{t('errors.region_forbidden')}</div>
    </div>
  )
}
